module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ackhd"
  }, [_vm._v("SPECIAL ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("I have been fortunate to have the most wonderful people helping me throughout the process of designing, writing, editing, and photographing this book. I would like to thank each and every person whose expertise has touched these pages. Special thanks go to Liz and Katie, my editors—you know how special you are, and I do appreciate you.")]), _vm._v(" "), _c('p', {
    staticClass: "ackt"
  }, [_vm._v("Thank you also to those who bequeathed their precious bits of lace, fabric, trims, and buttons to me. I have enjoyed giving them a permanent home in my creations.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg2.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Beaded Tandletons variation")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba89002a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Fm_ack.vue
// module id = 63
// module chunks = 0